import { useCallback, useMemo, useState } from "react";

import type { WebSource } from "app/components/filters-bar/websource-filter/WebSourceFilter.types";

import { DeviceDistributionChartTitle } from "../../components/DeviceDistributionChartTitle/DeviceDistributionChartTitle";
import { useDeviceDistributionData } from "../../hooks/useDeviceDistributionData";

import { ChartBody } from "./components/ChartBody/ChartBody";
import { adaptPieChartDataRecords } from "./config/chartConfigUtils";
import { ChartContainer } from "./DeviceDistributionPieChart.styles";

type IDeviceDistributionPieChartProps = {
    webSource: WebSource;
};

export const DeviceDistributionPieChart = ({ webSource }: IDeviceDistributionPieChartProps) => {
    const { data, isLoading } = useDeviceDistributionData();
    const [activeLegendItem, setActiveLegendItem] = useState("");

    const pieChartData = useMemo(() => {
        return data ? adaptPieChartDataRecords(data) : [];
    }, [data]);

    const handleMouseOverChart = useCallback((e) => {
        setActiveLegendItem(e.target.name);
    }, []);

    const handleMouseOutChart = useCallback(() => {
        setActiveLegendItem("");
    }, []);

    return (
        <>
            <DeviceDistributionChartTitle webSource={webSource} />
            <ChartContainer>
                <ChartBody
                    isLoading={isLoading}
                    onMouseOutChart={handleMouseOutChart}
                    onMouseOverChart={handleMouseOverChart}
                    data={pieChartData}
                    activeLegendItem={activeLegendItem}
                />
            </ChartContainer>
        </>
    );
};
